export const getIsDev = () => process.env.NODE_ENV === 'development';
